var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homePage"}},[[_c('page-header-second'),_c('div',{staticClass:"body"},[_c('my-home-left',{attrs:{"num":_vm.num}}),_c('router-view',{attrs:{"num":_vm.num}})],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }